/**************************************************
 * Nombre:       Home_Cabana
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo_img from "../../../Recursos/fondo_cabana.png";
import cabana from "../../../Recursos/cabana.mp4";
import Tarjeta_Indicador from "../../Tarjetas/Tarjeta_Indicador";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useNavigate} from "react-router-dom";

const Home_Cabana = () => {
    const {sCell, sTab, masSM} = useResponsive()
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        direction={'row-reverse'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sTab ? 0 : 14}
                    >


                        <Grid container size={{xs: 12, sm: 7, md: 7}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 0 : -14}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    borderRight: 6,
                                    borderTop: 6,
                                    borderBottom: 6,
                                    borderColor: '#7A7A7A40',
                                    borderRadius: 2,
                                    p: sCell ? 4 : 8,
                                    pb: 4
                                }}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{
                                            fontFamily: "Raleway",
                                            fontSize: !masSM ? 32 : 48,
                                            fontWeight: 800,
                                            lineHeight: 1.1
                                        }}>
                                        Reconexión con la naturaleza y el bienestar
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography
                                        sx={{
                                            fontFamily: "Roboto",
                                            fontSize: 16,
                                            fontWeight: 400,
                                            lineHeight: 1.2,
                                            color: '#7A7A7A'
                                        }}>
                                        En Magaza Lodge encontrarás paz y armonía en medio de la naturaleza. Nuestras
                                        cabañas son el refugio perfecto para descansar, reconectar y renovar tu energía.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 6}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        <Grid container size={{xs: 4, sm: 4, md: 4}}
                                              sx={{
                                                  justifyContent: 'flex-start',
                                                  borderRight: 1,
                                                  borderColor: '#00000020'
                                              }}>
                                            <Tarjeta_Indicador item={{numero: 6, nombre: 'Suites'}}/>
                                        </Grid>

                                        <Grid container size={{xs: 4, sm: 4, md: 4}}
                                              sx={{
                                                  justifyContent: 'flex-start',
                                                  borderRight: 1,
                                                  borderColor: '#00000020'
                                              }}>
                                            <Tarjeta_Indicador item={{numero: 15, nombre: 'Hectareas'}}/>
                                        </Grid>

                                        <Grid container size={{xs: 4, sm: 4, md: 4}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Indicador item={{numero: 50, nombre: 'Experiencias'}}/>
                                        </Grid>

                                        <Grid
                                            container
                                            justifyContent={'center'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}
                                            sx={{mt: 6}}
                                            spacing={2}
                                        >

                                            <Button
                                                color={'primary'}
                                                onClick={() => navigate('/Suite/Terra')}
                                            >Ver Suite Terra</Button>

                                            <Button

                                                color={'primary'}
                                                onClick={() => navigate('/Suite/Aqua')}
                                            > Ver Suite Aqua</Button>

                                        </Grid>

                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 5, md: 5}} sx={{
                            justifyContent: 'flex-start', border: 5,
                            borderColor: '#fff',
                            mt: sCell ? -6 : 0
                        }}>
                            <video width={'100%'} height={!masSM ? 640 : 720}
                                   style={{
                                       objectFit: 'cover',
                                       borderTopRightRadius: 160,
                                       zIndex: 1,

                                   }}
                                   id="background-video" autoPlay loop muted poster={fondo_img}>
                                <source src={cabana} type="video/mp4"/>
                            </video>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Cabana

